const BeautifyDecimal = (value: number, fractionDigits: number = 2) => {
    const decimalValue = value.toFixed(fractionDigits);
    return Number.isInteger(decimalValue) ? parseInt(decimalValue, 10) : decimalValue;
};

export default BeautifyDecimal;


// WEBPACK FOOTER //
// ./src/utils/BeautifyDecimal.ts